import { FC, Fragment } from 'react'
import Link from 'next/link'

type Props = {
  items: Item[]
}

type Item = {
  title: string
  link?: string
}

const breadcrum = (i: Item) => {
  if (i.link !== undefined) {
    return (
      <Link href={i.link} prefetch={false}>
        <a className="text-secondary-700 whitespace-nowrap">{i.title}</a>
      </Link>
    )
  }
  return <p className="line-clamp-1">{i.title}</p>
}

const Layout: FC<Props> = ({ items }) => {
  return (
    <>
      <section className="flex gap-4 items-center md:w-full md:flex-start">
        {items.map((i, idx) => {
          return (
            <Fragment key={i.title}>
              {breadcrum(i)}
              {idx !== items.length - 1 ? <div className="rounded-full bg-black w-1 h-1" /> : <></>}
            </Fragment>
          )
        })}
      </section>
    </>
  )
}

export default Layout
